// Resolves a page's og:image: its own photo first, then the generated card
// from scripts/generate-og-images.mjs, then the site logo.
import OG_IMAGES from "../data/__generated__/ogImages.json";
import { SITE, withTrailingSlash } from "./site";

const MAP = OG_IMAGES as Record<string, { image: string; title: string }>;

export function resolveOgImage(path: string, image?: string): string {
  if (image && image !== SITE.ogImage) return image;
  return MAP[withTrailingSlash(path)]?.image ?? SITE.ogImage;
}
